module.exports = __webpack_public_path__ + "static/img/2_Databee_officialaccount.ed8dbc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcodes/2_Databee_officialaccount.jpg
// module id = +MCC
// module chunks = 1